export enum EventName {
    MessageReceived = 'MESSAGE_RECEIVED',
    MessageSent = 'MESSAGE_SENT',
    SendMessageFailed = 'SEND_MESSAGE_FAILED',
    SessionChanged = 'SESSION_CHANGED',
    LoggedIn = 'LOGGED_IN',
    LoginFailed = 'LOGIN_FAILED',
    LoggedOut = 'LOGGED_OUT',
    TokenIsAboutToExpire = 'TOKEN_IS_ABOUT_TO_EXPIRE',
    TimelineItemSkipped = 'TIMELINE_ITEM_SKIPPED',
    WindowHashtagChanged = 'WINDOW_HASHTAG_CHANGED',
    ImagePreview = 'IMAGE_PREVIEW',
    ProactiveExperienceViewed = 'PROACTIVE_EXPERIENCE_VIEWED',
    FabioClicked = 'FABIO_CLICKED',
    ChatToggleAnimationEnded = 'CHAT_TOGGLE_ANIMATION_ENDED',
    DrawerEvent = 'DRAWER_EVENT',
    ExpertsAvailabilityChanged = 'EXPERTS_AVAILABILITY_CHANGED',
}
